
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1u26h_im8v7_5"
};
  